export default __webpack_public_path__ + "static/media/Bangles-Category-list.9a3623f9.jpg";